<template>
  <div>
    <div style="width: 100%;text-align: right;">
      <el-row :gutter="12">
        <el-col :span="2" >
          <el-button type="primary" @click="readyNewPlacement">新增</el-button>
        </el-col>
        <el-col :span="22">
          <div style="width: 100%;text-align: right;">
            <el-select placeholder="发展水平" v-model="condition.developmentLevel" style="width: 150px;" clearable>
              <el-option label="发达" value="1"/>
              <el-option label="发展中" value="2"/>
              <el-option label="欠发达" value="3"/>
              <el-option label="落后" value="4"/>
            </el-select>
            <el-input placeholder="请输入地址" v-model="condition.address" style="width: 200px" clearable/>
            <el-button @click="updateTable()" icon="el-icon-search" style="margin-left: 3px;">搜索</el-button>
          </div>
        </el-col>
      </el-row>

    </div>
    <div style="margin-top: 15px;">
      <el-table ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                element-loading-text="数据正在加载中"
                @selection-change="handleSelectionChange"
                :header-cell-style="headClass"
                :row-style="rowClass">
        <!--<el-table-column type="selection" width="60"></el-table-column>-->
        <el-table-column prop="placementId" label="ID" width="60" ></el-table-column>
        <el-table-column label="发展水平" width="120" >
          <template slot-scope="scope">
              <span v-if="scope.row.developmentLevel === 1">发达</span>
              <span v-if="scope.row.developmentLevel === 2">发展中</span>
              <span v-if="scope.row.developmentLevel === 3">欠发达</span>
              <span v-if="scope.row.developmentLevel === 4">落后</span>
          </template>
        </el-table-column>
        <el-table-column prop="province" label="省份" width="120" ></el-table-column>
        <el-table-column prop="city" label="城市" width="120"></el-table-column>
        <el-table-column prop="district" label="区域" width="120"></el-table-column>
        <el-table-column prop="address" label="地址" ></el-table-column>
        <el-table-column prop="longtitude" label="经度" ></el-table-column>
        <el-table-column prop="latitude" label="纬度" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <button @click="getMessage(scope.row)">查看</button>
            <button @click="deletePlacement(scope.row.placementId)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 50, 100, 200]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
      <el-dialog title="新增投放点" :visible.sync="isNew" width="500px" :close-on-click-modal="false">
        <el-form ref="placementNewForm" label-width="80px" :rules="placementNewRules" :model="placementNewForm">
              <el-form-item label="省市区" prop="selectList">
                <el-cascader
                  :options="addressList"
                  style="width: 240px;"
                  :props="commodityProps"
                  v-model="placementNewForm.selectList"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input v-model="placementNewForm.address" style="width: 240px;"/>
                <el-button type="primary" @click="showMapDialog">打开地图</el-button>
              </el-form-item>
              <el-form-item label="经度" prop="longtitude">
                <el-input v-model="placementNewForm.longtitude" style="width: 240px;"/>
              </el-form-item>
              <el-form-item label="纬度" prop="latitude">
                <el-input v-model="placementNewForm.latitude" style="width: 240px;"/>
              </el-form-item>
              <el-form-item label="发展水平" prop="developmentLevel">
                <el-select v-model="placementNewForm.developmentLevel" style="width: 240px;">
                  <el-option label="发达" value="1"/>
                  <el-option label="发展中" value="2"/>
                  <el-option label="欠发达" value="3"/>
                  <el-option label="落后" value="4"/>
                </el-select>
              </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isNew = false">取 消</el-button>
          <el-button type="primary" v-if="addPlacement" @click="submitNewPlacement('add')">新 增</el-button>
          <el-button type="primary" v-if="updatePlacement" @click="submitNewPlacement('update')">修 改</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="isShowMapDialog">
        <div style="display:flex;">
          <el-input v-model="searchValue" @keyup.enter.native="mapSearch" />
          <el-button :loading="searchLoading" style="margin-left:10px" type="primary" @click="mapSearch">搜索</el-button>
        </div>
        <el-amap ref="map" :plugin="plugins" :events="events" :zoom.sync="zoom" :center="center" style="width: 100%;height: 300px;margin-top: 10px">
          <el-amap-marker :position="lnglat" />
        </el-amap>
        <div style="margin-top: 10px;display:flex;justify-content: flex-end">
          <el-button type="danger" @click="isShowMapDialog = false">取消</el-button>
          <el-button type="primary" @click="updateDeviceGeo">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {getAddressList} from "../../assets/js/area";
    import VueAMap, {lazyAMapApiLoaderInstance} from 'vue-amap'

    export default {
        name: "placement",
        data() {
          var validSelectList = (rule, value, callback) => {
            if (value.length != 3) {
              callback(new Error('请完整地选择地址!'));
            } else {
              callback();
            }
          }
          return {
            total: 0,
            currentPage: 1,
            pageSize: 10,
            tableData:[],
            condition: {
              province: '',
              city: '',
              district: '',
              address: '',
              developmentLevel: '',
            },
            isNew: false,
            addPlacement: false,
            updatePlacement: false,
            addressList: [],
            commodityProps: {
              value: 'label',
              label: 'label'
            },
            placementNewForm: {
              placementId: 0,
              selectList: [],
              developmentLevel: '',
              address: '',
              longtitude:'', // 这里和后台的字段写错了，正确的单词应该是 longitude
              latitude:'',
            },
            placementNewRules: {
              selectList: [{ trigger: 'change', required: true, message: '请选择地址!' }, { trigger: 'change', validator: validSelectList }],
              address:[{ trigger: 'blur',required: true, message: '地址不能为空!'}],
              developmentLevel:[{ trigger: 'change',required: true, message: '请选择投放点发展程度!'}],
              longtitude:[{ trigger: 'change',required: true, message: '请输入经度!'}],
              latitude:[{ trigger: 'change',required: true, message: '请输入纬度!'}],
            },
            // 地图
            plugins: [{
              pName: 'ToolBar',
              liteStyle: true
            }],
            isShowMapDialog: false,
            address: '',
            lnglat: [0, 0],
            center: [107.045029, 35.433268],
            searchValue: '',
            mapLoading: false,
            searchLoading: false,
            zoom: 3,
            options: [],
            gsm: {},
            events: {
              click: (e) => {
                this.mapLoading = true
                lazyAMapApiLoaderInstance.load().then(() => {
                  const geoCoder = new AMap.Geocoder({ radius: 1000, extensions: 'all' })
                  console.log(this.$refs.map)
                  console.log(AMap)
                  console.log(e)
                  const lnglat = [e.lnglat.lng, e.lnglat.lat]
                  this.lnglat = lnglat
                  geoCoder.getAddress(lnglat, (status, result) => {
                    if (status === 'complete' && result.regeocode) {
                      console.log(result,"click_result")
                      this.address = result.regeocode.formattedAddress
                      this.searchValue = result.regeocode.formattedAddress
                      this.placementNewForm.longtitude = result.regeocode.aois[0].location.lng;
                      this.placementNewForm.latitude = result.regeocode.aois[0].location.lat;
                    } else {
                      console.error('根据经纬度查询地址失败')
                    }
                    this.mapLoading = false
                  })
                })
              }
            }
          }
        },
      mounted() {
          this.updateTable()
      },
      methods: {
          updateTable(){
            var params = {
              pageId:this.currentPage,
              size:this.pageSize,
              developmentLevel: this.condition.developmentLevel,
              address: this.condition.address,
            };
            const loading = this.$loading({
              lock: true,
              text: '获取表格数据中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
              loading.close();
            }, 3000);
            var thiz = this;
            axios.get(this.$store.getters.getApiValue+'/placement/list.do',{
              params:params
            }).then(function (response) {
              loading.close();
              var data = response.data;
              if(data.status == "200"){
                thiz.total = data.totalCount;
                thiz.tableData = data.data;
              }
            }).catch(function (error) {
              loading.close();
              console.log(error);
            });

          },
          getMessage(row) {
            this.isNew = true;
            this.addPlacement = false;
            this.updatePlacement = true;
            this.$nextTick(()=>{
              this.$refs['placementNewForm'].clearValidate() // 只清除清除验证
            });
            this.addressList = getAddressList();
            this.placementNewForm.selectList = [];
            this.placementNewForm.selectList.push(row.province);
            this.placementNewForm.selectList.push(row.city);
            this.placementNewForm.selectList.push(row.district);
            this.placementNewForm.address = row.address;
            this.placementNewForm.longtitude= row.longtitude;
            this.placementNewForm.latitude=row.latitude;
            this.placementNewForm.developmentLevel = row.developmentLevel+'';
            this.placementNewForm.placementId = row.placementId;
            this.gsm.longitude = row.longtitude;
            this.gsm.latitude = row.latitude;
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          handleSizeChange(val) {
            this.pageSize = val;
            this.updateTable();
          },
          handleCurrentChange(val) {
            this.currentPage = val;
            this.updateTable();
          },
          readyNewPlacement(){
            this.isNew = true;
            this.addPlacement = true;
            this.updatePlacement = false;
            this.$nextTick(()=>{
              this.$refs['placementNewForm'].clearValidate() // 只清除清除验证
            });
            this.placementNewForm.selectList = [];
            this.placementNewForm.address = '';
            this.placementNewForm.developmentLevel = '';
            this.addressList = getAddressList();
            this.gsm.longitude = 116.397755;
            this.gsm.latitude = 39.903179;
          },
          submitNewPlacement(method){
            var thiz = this;
            const loading = this.$loading({
              lock: true,
              text: '操作执行中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            if (method === 'add'){
              var params1 = {
                province: this.placementNewForm.selectList[0],
                city: this.placementNewForm.selectList[1],
                district: this.placementNewForm.selectList[2],
                address: this.placementNewForm.address,
                developmentLevel: this.placementNewForm.developmentLevel,
                longtitude:this.placementNewForm.longtitude,
                latitude:this.placementNewForm.latitude
              };
              axios.get(this.$store.getters.getApiValue+'/placement/add.do',{
                params:params1
              })
                .then(function (response) {
                  loading.close()
                  var data = response.data
                  if (data.status == '200') {
                    if (data.data) {
                      thiz.$message.success('操作成功！')
                      thiz.isNew = false;
                      thiz.updateTable()
                    } else {
                      thiz.$message.success('操作失败！')
                      thiz.isNew = false;
                      thiz.updateTable()
                    }
                  } else {
                    thiz.$message.error(data.message)
                  }
                })
                .catch(function (error) {
                  loading.close()
                  console.log(error)
                  thiz.$message.error('系统异常!请与管理员联系!')
                  thiz.isNew = false;
                })
            }else if (method === 'update'){
              var params2 = {
                placementId : this.placementNewForm.placementId,
                province: this.placementNewForm.selectList[0],
                city: this.placementNewForm.selectList[1],
                district: this.placementNewForm.selectList[2],
                address: this.placementNewForm.address,
                developmentLevel: this.placementNewForm.developmentLevel,
                longtitude:this.placementNewForm.longtitude,
                latitude:this.placementNewForm.latitude
              };
              axios.get(this.$store.getters.getApiValue+'/placement/update.do',{
                params:params2
              })
                .then(function (response) {
                  loading.close()
                  var data = response.data
                  if (data.status == '200') {
                    if (data.data) {
                      thiz.$message.success('操作成功！')
                      thiz.isNew = false;
                      thiz.updateTable()
                    } else {
                      thiz.$message.success('操作失败！')
                      thiz.isNew = false;
                      thiz.updateTable()
                    }
                  } else {
                    thiz.$message.error(data.message)
                  }
                })
                .catch(function (error) {
                  loading.close()
                  console.log(error)
                  thiz.$message.error('系统异常!请与管理员联系!')
                  thiz.isNew = false;
                })
            }
          },
        deletePlacement(id){
          var thiz = this;
          this.$confirm("确认删除该投放点吗?'")
            .then(_ => {
              axios.get(thiz.$store.getters.getApiValue + '/placement/del.do', {
                params: {
                  placementId: id
                }
              }).then(response => {
                var data = response.data;
                if (data.status == "200") {
                  if (data.data != "" && data.data != null) {
                    thiz.$message.success("删除成功!");
                    thiz.updateTable();
                  }
                } else {
                  thiz.$message.error(data.message);
                }
              }).catch(function (error) {
                thiz.$message.error("系统异常,请与管理员联系!");
              })
            }).catch(_ => { });
        },

        headClass({ row, rowIndex}) {
          if(rowIndex == 0){
            return ''
          }
          return ''
        },
        rowClass({ row, rowIndex}) {
          if(rowIndex%2 == 0){
            return 'background:#F1F2F7;'
          }else{
            return 'background:white;'
          }
          return ''
        },
        // 地图
        updateDeviceGeo() {
          this.placementNewForm.address = this.searchValue;
          this.$nextTick(()=>{
            this.$refs['placementNewForm'].clearValidate() // 只清除清除验证
          });
          this.isShowMapDialog = false
        },
        showMapDialog() {
          this.searchValue = this.gsm.address
          this.lnglat = [this.gsm.longitude, this.gsm.latitude]
          this.center = [this.lnglat[0], this.lnglat[1]]
          this.zoom = 16
          this.isShowMapDialog = true
        },
        mapSearch() {
          this.searchLoading = true
          lazyAMapApiLoaderInstance.load().then(() => {
            const geoCoder = new AMap.Geocoder()
            geoCoder.getLocation(this.searchValue, (status, result) => {
              console.log(status, "status")
              console.log(result, "result")
              if (status === 'complete' && result && result.geocodes) {
                this.options = result.geocodes
                this.zoom = 14
                const location = result.geocodes[0].location
                this.center = [location.lng, location.lat]
                this.placementNewForm.longtitude = location.lng;
                this.placementNewForm.latitude = location.lat;
              }
              this.searchLoading = false
            })
          })
        },
        }
    }
</script>

<style scoped>

</style>
